<template>
  <div class="header">
    <div class="logoBox" v-if="showLogo" @click="toHome">
      <img class="bigImg" :src="require('img/menu/logoText.png')" />
    </div>
    <div class="userTag" v-if="userInfo.userId">
      <el-dropdown @visible-change="visibleChange">
        <div :class="{ infoContainer: true, hover: avatarHover }">
          <div class="avatar_top"></div>
          <img
            class="avatar"
            :src="
              userInfo.avatar ||
                require('../../assets/img/headers/drop/defaultHead.svg')
            "
            alt=""
          />
          <span class="userName">
            {{ userInfo.nickName }}
          </span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown" class="userInfo_drop_down">
          <UserInfo />
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <span v-else class="toLogin" @click="signIn">登录&nbsp;|&nbsp;注册</span>
    <a
      class="btn"
      href="https://file.foxitreader.cn/file/Channel/foxitprinter/print01_FoxitprinterSetup.exe"
    >
      下载客户端
    </a>
  </div>
</template>

<script>
import axios from "axios";
import { REQUEST_URL, PRINT_TO_DOCS_APP_KEY } from "const";
import UserInfo from "./UserInfo.vue";
import { signIn, logout } from "../../utils/utils";
import { mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      avatarHover: false
    };
  },
  props: {
    showLogo: {
      type: Boolean
    },
    info: {
      type: Object
    }
  },
  components: {
    UserInfo
  },
  computed: {
    ...mapState("user", ["userInfo"])
  },
  mounted() {
    // this.getDocToken();
  },
  methods: {
    /**
     * [signIn 登录]
     *
     * @return  {[type]}  [return description]
     */
    signIn() {
      signIn();
    },
    visibleChange(value) {
      this.avatarHover = value;
    },
    toHome() {
      this.$router.push({ name: "index" });
    },
    getDocToken() {
      if (!window?.readerCookies?.fid) return;
      const service = axios.create({
        withCredentials: true
      });
      const url = `https://docsapi.foxitcloud.cn/user/getExchangeToken`;
      service
        .get(url, { params: { appKey: PRINT_TO_DOCS_APP_KEY } })
        .then(res => {
          const {
            data: { data }
          } = res;
          if (res.data.code !== 0) return;
          localStorage.setItem(
            "docToken",
            JSON.stringify({
              token: data.token,
              expireTime:
                new Date().getTime() + data.expireTime * 1000 - 300 * 1000
            })
          );
        })
        .catch(() => {});
    },
    logout() {
      localStorage.clear();
      logout();
    },
    setUserInfo(userInfo) {
      this.userInfo = userInfo;
    }
  }
};
</script>

<style lang="scss" scoped>
$theme-color: #1a4bff;
.header {
  width: 100%;
  min-width: 400px;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  position: relative;
}

.logoBox {
  position: absolute;
  left: 30px;
  height: 31px;
  top: 0;
  cursor: pointer;
  width: 114px;
  .bigImg {
    position: absolute;
    width: 114px;
  }
}

.infoContainer {
  display: flex;
  align-items: center;
  position: relative;
  .avatar_top {
    position: absolute;
    width: 32px;
    height: 32px;
    left: 0;
    top: 0;
    z-index: 1;
    border-radius: 16px;
  }
}

.infoContainer.hover {
  .avatar_top {
    background: #000;
    opacity: 0.1;
  }
}

.userTag {
  margin-left: 40px;
  cursor: pointer;
  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 16px;
    margin-right: 10px;
  }
  .userName {
    line-height: 18px;
    width: 80px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #666666;
  }
}

.toLogin {
  padding-left: 30px;
  font-size: 14px;
  cursor: pointer;
  color: #666666;
  &:hover {
    color: $theme-color;
  }
}

.btn {
  display: block;
  width: 90px;
  height: 32px;
  background: linear-gradient(122deg, #fe8a26 0%, #fe6d26 100%),
    linear-gradient(#ff9025, #ff9025);
  background-blend-mode: normal, normal;
  box-shadow: 0px 2px 6px 0px rgba(240, 79, 0, 0.28);
  border-radius: 15px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  line-height: 32px;
  cursor: pointer;
  text-align: center;
  &:hover {
    background: linear-gradient(122deg, #fe8126 0%, #f4551e 100%);
  }
}
</style>

<style>
.userInfo_drop_down {
  padding: 0;
  /* box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.2);
  border-radius: 4px 4px 4px 4px; */
}
</style>
